import { Button, dialog, FormFactory } from "nq-component";
import CardView from "../../../../components/common/CardView";
import BasePage from "../../../../base/BasePage";
import {
  FloatingForm,
  ServiceRecordLeave,
} from "../../../../components/common/Converter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
export default class Suspension extends BasePage {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChangeForm(val, field) {
    this.setState({ [field]: val });
  }

  dialogClose() {
    dialog.close();
  }

  handleOnChange(field, value) {
    this.setState({ [field]: value });
  }

  async handleClickOk() {
    if (this.state.submitting) return;

    this.submitting();
    const { reason, effectivityDate } = this.state;
    const suspensionDate = new Date(effectivityDate).toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    );

    const data = {
      id: this.props.object.id,
      suspension: true,
      dateOfSuspension: suspensionDate,
    };

    try {
      delete data.selectedSchedule;
      await upsertUseCase().execute("employees", data);
      this.insertServiceRecord(this.props.object, reason, effectivityDate);
      this.props.closeSeparation();
      this.showSuccess("Data Successfully saved!");
      this.props.refetchData();
    } catch (e) {
      console.error("error: ", e);
      this.submissionError();
    } finally {
      this.submissionSuccess();
    }
  }

  async insertServiceRecord(updateEmployee, reason, effectivityDate) {
    const effectivity =
      (effectivityDate && new Date(effectivityDate)) || new Date();
    const serviceRec = await findObjectUseCase().execute("service_record", {
      where: { empID: updateEmployee?.id, to: { $exists: false } },
    });

    const dateFrom = serviceRec[0]?.from
      ? new Date(serviceRec[0]?.from)
      : new Date();
    dateFrom.setDate(dateFrom.getDate() - 1);
    const leaveReq = await findObjectUseCase().execute("leave_request", {
      where: {
        employee: { id: updateEmployee.id },
        stats: { $ne: "For Processing" },
        $or: [
          { startdate: { $gte: dateFrom, $lte: effectivity } },
          { enddate: { $gte: dateFrom, $lte: effectivity } },
        ],
      },
    });

    let salary = "";
    if (updateEmployee?.salaryGrade) {
      salary = updateEmployee?.salaryGrade.replace(
        /₱\s?([\d,]+\.\d{2})/,
        (_, num) => `₱ ${(parseFloat(num.replace(/,/g, "")) * 12).toFixed(2)}`
      );
    }

    const serviceLog = {
      email: updateEmployee?.email,
      empID: updateEmployee?.id,
      from: effectivity,
      employee: { id: updateEmployee.id },
      designation: updateEmployee.position.position_title,
      status: updateEmployee?.employmentType?.name || "",
      salary: salary,
      station: "BUREAU OF IMMIGRATION",
      branch: "NATIONAL",
      cause: reason,
    };

    // console.log("serviceLog: ", serviceLog);
    // return;

    if (serviceRec.length > 0) {
      let leaveStatus = [];
      for (const leave of leaveReq) {
        // Extract and abbreviate the selectedType
        const selectedType = leave.selectedType;
        const abbreviation = selectedType
          .split(" ") // Split the string into an array of words
          .map((word) => word.charAt(0)) // Take the first letter of each word
          .join(""); // Join them back together

        // Format the startDate and endDate
        leaveStatus.push(
          ServiceRecordLeave(
            abbreviation,
            new Date(leave?.startdate),
            new Date(leave?.enddate)
          )
        ); // Add to the result array
      }

      serviceRec[0].to = serviceLog?.from;
      serviceRec[0].leave = leaveStatus;
      serviceRec[0].status = serviceLog?.status;
      await upsertUseCase().execute("service_record", serviceRec[0]);
    }
    await upsertUseCase().execute("service_record", serviceLog);
  }

  render() {
    const schema = {
      collection: "suspension",
      fields: {
        reason: {
          type: "String",
          _type: "Text",
          placeholder: "Reason",
          required: true,
        },
        effectivityDate: {
          type: "Date",
          required: true,
        },
      },
    };

    return (
      <>
        <FloatingForm width="40rem">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleClickOk();
            }}
          >
            <CardView style={{ padding: 0 }}>
              <h4 className="fs-6 fw-bold pt-3 ps-3">Suspension</h4>
              <hr />
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <div className="pb-4">
                  <FormFactory
                    schema={schema}
                    className="col-lg-12 mb-2"
                    // object={object}
                    onChange={this.onChangeForm.bind(this)}
                    excludeFields={[]}
                  />
                  {/* <InputFactory
                    type="Text"
                    fields={fields}
                    onChange={(val) => this.handleReasonChange(val)}
                    required={true}
                  /> */}
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  type="button"
                  onClick={() => this.props.closeSeparation()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  type="submit"
                  progress={this.state.submitting}
                  disabled={this.state.submitting}
                >
                  OK
                </Button>
              </div>
            </CardView>
          </form>
        </FloatingForm>
      </>
    );
  }
}
